document.addEventListener('DOMContentLoaded', function () {

  // Variant click handler
  document.querySelectorAll('.product-variants-list span').forEach(function (el) {

    el.addEventListener('click', function () {

      const parent = el.closest('.product-card-wrapper');

      // Remove active from siblings
      parent.querySelectorAll('.product-variants-list span').forEach(s => s.classList.remove('active'));
      el.classList.add('active');

      // Get data
      const variantId = el.dataset.id;
      const price = el.dataset.price;
      const comparePrice = el.dataset.comparePrice;
      const image = el.dataset.img;
      const available = el.dataset.available === "true";
      const promo = el.dataset.promo;
      const minQty = el.dataset.minQty;

      // Update hidden variant ID
      const input = parent.querySelector('.product-variant-id');
      if (input) input.value = variantId;

      // Update image
      if (image) {
        const img = parent.querySelector('.card__media img');
        if (img) img.src = image;
      }

      // Update price
      const priceContainer = parent.querySelector('.price');
      if (priceContainer && price) {
        const regularPrice = priceContainer.querySelector('.price-item--regular');
        if (regularPrice) regularPrice.innerHTML = price;

        const compare = priceContainer.querySelector('.price-item--sale');
        if (compare && comparePrice) compare.innerHTML = comparePrice;
      }

      // Update promo text
      const promoEl = parent.querySelector('.current_variant_promo');
      if (promoEl) {
        if (minQty) {
          promoEl.innerHTML = minQty;
        } else if (promo) {
          promoEl.innerHTML = promo;
        } else {
          promoEl.innerHTML = '';
        }
      }

      // Update button state
      const btn = parent.querySelector('button[name="add"]');
      if (btn) {
        if (available) {
          btn.disabled = false;
          btn.classList.remove('sold-out');
        } else {
          btn.disabled = true;
          btn.classList.add('sold-out');
        }
      }

    });

  });

});